import { gql, useLazyQuery } from '@apollo/client';
import { Grid } from '@mui/material';
import AutocompleteWithFetch from 'components/Inputs/AutoCompletewithFetch';
import { Select } from 'components/Inputs/Select';
import LoadingIndicator from 'components/LoadingIndicator';
import Navbar from 'components/Navbar';
import CreateEmployeeForm from 'components/Users/Forms/CreateEmployee';
import UpdateEmployeeForm from 'components/Users/Forms/UpdateEmployee';

import {
  GET_USERS_QUERY,
  GetUserByIdResponse,
  GetUserByIdVariables,
  GetUsersQueryResponse,
  GetUsersQueryVariables,
} from 'graphql/query/user';
import { useState } from 'react';
import { getSelectedObjectiveGoalsYear } from 'utils/common';

enum UserOperation {
  ADD = 'ADD',
  UPDATE = 'UDPATE',
}

const GET_USER_BY_ID_QUERY = gql`
  query GetUserById($user: ID!) {
    getUserById(user: $user) {
      _id
      empId
      name
      email
      role {
        _id
        name
      }
      department
      designation
      hod {
        _id
        name
      }
      reportingManager {
        _id
        name
      }
      location
      band
      level
    }
  }
`;

const CreateEmployee = () => {
  const [userOperation, setUserOperation] = useState(UserOperation.ADD);
  const [userToUpdate, setUser] = useState({ _id: '', name: '' });

  const [getUsers, { loading: loadingUsers, data: users }] = useLazyQuery<
    GetUsersQueryResponse,
    GetUsersQueryVariables
  >(GET_USERS_QUERY);

  const [getUserById, { loading: loadingSelectedUser, data: selectedUser }] = useLazyQuery<
    GetUserByIdResponse,
    GetUserByIdVariables
  >(GET_USER_BY_ID_QUERY);

  const handleSelectUser = val => {
    if (!!val._id) {
      getUserById({
        variables: {
          user: val._id,
        },
      });
    }
    setUser(val);
  };

  return (
    <Navbar
      title={`${userOperation === UserOperation.ADD ? 'Add' : 'Update'} Employee - ${getSelectedObjectiveGoalsYear()}`}
    >
      <Grid container px={1} py={1} md={10} lg={8} columnSpacing={2} rowGap={2}>
        <Grid item xs={12}>
          <Select
            value={userOperation}
            onChange={val => {
              setUserOperation(val);
              setUser({ _id: '', name: '' });
            }}
            options={Object.keys(UserOperation).map(k => ({ label: k, value: UserOperation[k] }))}
            label="Add / Update Employee"
            required
          />
        </Grid>
        {userOperation === UserOperation.UPDATE && (
          <Grid item xs={12}>
            <AutocompleteWithFetch
              value={userToUpdate}
              handleChange={val => handleSelectUser(val)}
              label="Select Employee"
              required
              loading={loadingUsers}
              fetch={getUsers}
              options={users?.getUsers ?? []}
            />
          </Grid>
        )}
        {userOperation === UserOperation.UPDATE ? (
          loadingSelectedUser ? (
            <LoadingIndicator />
          ) : (
            !!selectedUser?.getUserById &&
            !!userToUpdate._id && <UpdateEmployeeForm initialData={selectedUser?.getUserById!} />
          )
        ) : (
          <CreateEmployeeForm />
        )}
      </Grid>
    </Navbar>
  );
};

export default CreateEmployee;
